import { ref } from "vue";

interface Toast {
  id: number;
  message: string;
  color: string;
  timeout: number;
}

const toasts = ref<Toast[]>([]);

export function useToast() {
  const showToast = (message: string, color = "success", timeout = 3000) => {
    const id = Date.now();
    toasts.value.push({ id, message, color, timeout });
    setTimeout(() => dismiss(id), timeout);
  };

  const dismiss = (id: number) => {
    toasts.value = toasts.value.filter((t) => t.id !== id);
  };

  return { toasts, showToast, dismiss };
}
